import { useCurrentTenant } from "@drift/oneplatfront-components";
import { CodeViewer } from "@onefront/react-workspace-components";
import { CslFormLookup, ExtendedMenuItem, ExtendedSelect } from "@onefront/workspace-forms";
import { ExtendedTypography } from "@vapor/react-extended";
import { Button, Grid, Stack, TextField, Toggle } from "@vapor/react-material";
import { useState } from "react";
import { CslType } from "../../../../@types/enums/general/Csl";

export const CslFormSmartDemo = () => {
    const { tenant } = useCurrentTenant(true);
    const [relationType, setRelationType] = useState<"CUSTOMER" | "SUPPLIER">("CUSTOMER");
    const [officeData, setOfficeData] = useState<boolean>(false);
    const [creditLinesData, setCreditLinesData] = useState<boolean>(false);
    const [selectData, setSelectData] = useState<any>(null);
    const [submitData, setSubmitData] = useState<any>(null);

    return (
        <Stack width={"100%"} maxWidth={"1280px"} margin={"0 auto"} gap={3}>
            <Stack direction="row" gap={2} alignItems="center" justifyContent={"space-between"}>
                <ExtendedTypography variant="titleLarge">CSL Form Smart Demo</ExtendedTypography>
                <Button variant="contained" color="primary" onClick={() => window.open("/csl", "_blank")}>
                    CSL PAGE
                </Button>
            </Stack>
            <Grid container rowGap={2} columnGap={2} justifyContent="space-between" alignItems={"center"}>
                <Grid item xs={3.5}>
                    <TextField label={"Tenant Workspace ID"} value={tenant?.id} readOnly />
                </Grid>
                <Grid item xs={3.5}>
                    <ExtendedSelect
                        label={"Relation Type"}
                        value={relationType}
                        onChange={e => setRelationType(e.target.value as any)}
                        required
                    >
                        <ExtendedMenuItem value={CslType.CUSTOMER} label={CslType.CUSTOMER}>
                            CUSTOMER
                        </ExtendedMenuItem>
                        <ExtendedMenuItem value={CslType.SUPPLIER} label={CslType.SUPPLIER}>
                            SUPPLIER
                        </ExtendedMenuItem>
                    </ExtendedSelect>
                </Grid>
                <Grid item xs={4.5}>
                    <Stack direction={"row"}>
                        <Stack direction="row" gap={1} alignItems="center">
                            <ExtendedTypography variant="body700">Office Data</ExtendedTypography>
                            <Toggle checked={officeData} onChange={e => setOfficeData(e.target.checked)} />
                        </Stack>
                        <Stack direction="row" gap={1} alignItems="center">
                            <ExtendedTypography variant="body700">Creditlines Data</ExtendedTypography>
                            <Toggle checked={creditLinesData} onChange={e => setCreditLinesData(e.target.checked)} />
                        </Stack>
                    </Stack>
                </Grid>
            </Grid>
            <CslFormLookup
                workspaceId={tenant?.id}
                relationType={relationType}
                onClear={() => {
                    setSelectData(null);
                }}
                onSelect={(data: any) => {
                    setSelectData(data);
                }}
                onSubmit={data => {
                    setSubmitData(data);
                }}
                officeData={officeData}
                creditLinesData={creditLinesData}
            />
            <CodeViewer json={selectData} label="onSelect Data" display />
            <CodeViewer json={submitData} label="onSubmit Data" display />
        </Stack>
    );
};
